module.exports = __webpack_public_path__ + "img/IMG-20191106-WA0035.f7d0b170.jpg";